<!--
 * @Description: 
 * @Author: xutao
 * @Date: 2020-11-13 14:20:25
 * @LastEditors: xutao
 * @LastEditTime: 2020-12-08 15:42:09
-->
<template>
  <div class="avatar-box">
    <div class="avatar" :class="{'animate' : animate}">
      <img :src="userInfo.headUrl" alt="">
    </div>
    <p class="nickname">{{ userInfo.nickName || '云集好友' }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchUserInfo } from '../api/home'
import bus from '../js/bus'
import { CUSTOM_EVENT_ID } from '../define/customEventId'

export default {
  name: 'avatar',
  data() {
    return {
      animate: false,
      userInfo: {}
    }
  },
  created() {
    this.getShareUserInfo()
  },
  methods: {
    getShareUserInfo() {
      fetchUserInfo({
        appCont: this.appCont,
        shopId: this.shopId
      }).then((res) => {
        if (res.code === 0 || res.errorCode === 0) {
          this.userInfo = res.data || {}
          bus.$emit(CUSTOM_EVENT_ID.GET_USER_INFO_BY_SHOPID, this.userInfo)
        }
      })
    }
  },
  computed: {
    ...mapGetters(['appCont', 'shopId'])
  }
}
</script>

<style lang="less" scoped>
.avatar-box {  
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .avatar {
    width: 1.6rem;
    height: 1.6rem;
    border: 0.06rem solid rgba(255,255,255,0.50);
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 0.28rem;
    &.animate {
      width: 1rem;
      height: 1rem;
      margin-bottom: 0.2rem;
      transition: all .5s;
    }
    img {
      display: block;
      width: 100%;
    }
  }
  .nickname {
    color: #EBDCFA;
    font-size: 0.24rem;
    height: 0.34rem;
    line-height: 0.34rem;
    text-align: center;
    font-weight: bold;
  }
}
</style>
